export default "__VITE_ASSET__CF0Vq$$4__"